import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success-grey",
  "use": "icon-success-grey-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-success-grey\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" opacity=\".01\" /><path fill=\"#000\" fill-opacity=\".09\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16\" clip-rule=\"evenodd\" /><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"m7.326 10.876-.6.6L4 8.751 5.202 7.55l1.523 1.524L10.798 5 12 6.202z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol